import React, { Component } from 'react';
import PracticeAdminMenu from './PracticeAdminMenu'
import { fetchPractice } from "../../actions/index"
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { setTitle } from "../../actions/index"
import PatientIcon from './images/PatientIcon'
import UserIcon from './images/UserIcon'
// import HelpAddPatients from './images/add-patient.gif'
// import HelpAssignUsers from './images/assign-users.gif'
// import HelpAssignPatient from './images/assign-patient.gif'
// import HelpAddPatientsFrame from './images/add-patient-frame.png'
// import HelpAssignUsersFrame from './images/assign-users-frame.png'
// import HelpAssignPatientFrame from './images/assign-patient-frame.png'

import "../ui/styles/instruction-bars.scss"


const widthStyle = {
	maxWidth: "420px",
	margin: "auto"
}
class RegisterSuccess extends Component {
	constructor(props) {
		super(props)
		this.state = {
			HelpAddPatients: false,
			HelpAssignUsers: false,
			HelpAssignPatient: false,
		}
		this.getPractice = this.getPractice.bind(this)
		this.goTo = this.goTo.bind(this);
		this.ownerAuth = this.ownerAuth.bind(this);
		this.play = this.play.bind(this);
	}


	componentDidMount() {
		this.getPractice()
	}

	componentWillReceiveProps(nextProps) {
		const { app, params } = this.props;
		const nextApp = nextProps.app;
		if (nextApp.practice.slug !== app.practice.slug) {
			this.getPractice(params.name)
		}
	}

	ownerAuth() {
		const { app, User, params, router } = this.props;
		// is this not an owner of this practice?

		if (!app.authed) return false;

		if (!User.ownPractices
			.find(p => params.name === p.id || params.name === p.slug)) {
			router && router.replace('/');
			return false
		}
		return true
	}

	goTo(url) {
		const { router } = this.props;
		router.push(url)
	}

	getPractice(name = this.props.params.name) {
		const { dispatch } = this.props
		return dispatch(fetchPractice(name))
			.then(action => {
				dispatch(setTitle(action.name))
			})
	}



	play(name) {

		this.setState({
			HelpAddPatients: false,
			HelpAssignUsers: false,
			HelpAssignPatient: false,
		})
		this.setState({
			[name]: !this.state[name]
		})
	}

	render() {
		const { params, app } = this.props;

		return (
      <main className="main practice-page">
        <PracticeAdminMenu params={params} active="help" />
        <div className="page height100 mb8">
          <h5 className="center primary-font-color1 vibrant">
            Let's get you started
          </h5>
          <div className="center md-body-1" style={widthStyle}>
            <p>
              Once you've been approved, an email will be sent to you with your
              unique Special T address which you can send to your users.
            </p>
            <p>
              In the mean time, you can set up your practice by following these
              simple steps.
            </p>
          </div>
          <div
            onClick={() =>
              this.goTo(`/practice_admin/${app.practice._id}/patients`)
            }
            className="instruction-bar primary-shade0 link"
          >
            <div>
              <PatientIcon />
            </div>
            <div>Step 1:</div>
            <div>Create new patient profiles</div>
          </div>

          <div className="center md-body-1 middle">
            <div
              style={{ position: "relative", maxWidth: "283px" }}
              className="card dark round-corners"
            >
              <iframe
                allowFullScreen="allowfullscreen"
                height="500px"
                className="youtube-frame"
                src={`https://www.youtube.com/embed/ZYpaX-tavuY`}
              />
              <button
                onClick={() =>
                  this.goTo(`/practice_admin/${app.practice._id}/patients`)
                }
                className="md-button dark"
              >
                Go there
              </button>
            </div>
          </div>

          <div
            onClick={() =>
              this.goTo(`/practice_admin/${app.practice._id}/users`)
            }
            className="instruction-bar primary-shade1 link"
          >
            <div>
              <UserIcon />
            </div>
            <div>Step 2:</div>
            <div>Assign roles for users</div>
          </div>

          <div className="center md-body-1 middle">
            <div
              style={{ position: "relative", maxWidth: "283px" }}
              className="card dark round-corners"
            >
              <iframe
                allowFullScreen="allowfullscreen"
                height="500px"
                className="youtube-frame"
                src={`https://www.youtube.com/embed/e0lQyYczayQ`}
              />
              <button
                onClick={() =>
                  this.goTo(`/practice_admin/${app.practice._id}/patients`)
                }
                className="md-button dark"
              >
                Go there
              </button>
            </div>
          </div>

          <div
            onClick={() =>
              this.goTo(`/practice_admin/${app.practice._id}/patients`)
            }
            className="instruction-bar primary-shade2 link"
          >
            <div>
              <PatientIcon />
            </div>
            <div>Great! Now connect your users to patients</div>
          </div>

          <div className="center md-body-1 middle">
            <div
              style={{ position: "relative", maxWidth: "283px" }}
              className="card dark round-corners"
            >
              <iframe
                allowFullScreen="allowfullscreen"
                height="500px"
                className="youtube-frame"
                src={`https://www.youtube.com/embed/HZRz-aMvqIY`}
              />
              <button
                onClick={() =>
                  this.goTo(`/practice_admin/${app.practice._id}/patients`)
                }
                className="md-button dark"
              >
                Go there
              </button>
            </div>
          </div>
        </div>
      </main>
    );
	}
}

const mapStateToProps = ({ User, app }) => ({ User: User.User, app });


export default connect(mapStateToProps)(withRouter(RegisterSuccess))


// WEBPACK FOOTER //
// ./src/components/practice_admin/RegisterSuccess.jsx